import React, { useState } from 'react'
import ContainerLayout from '../../../components/container-layout/ContainerLayout';
import NavigateListCustom from '../../../components/navigation/NavigationListCustom';
// import { RoutePath } from '../../../routes/Routes';
import StateComponents from '../../../components/state-component/StateComponents';
import { useNavigate, useParams } from 'react-router-dom';
import ModalMedia from '../media/modal-media/ModalMedia';
import { linkPreviewImage } from '../../../components/upload-image-preview/UploadImagePreview';
// import { STATUS_ENUM } from '../../manage-articles/enum/article.enum';
import ContainerButton from '../../../components/button/ContainerButton';
import { ManageStateDetail } from './manageStateDetail';
import BannerTypeContent from '../website-structure/content/element/BannerTypeContent';
import { IconComponents } from '../../../assets/icons/icons';
import { alertActive } from '../../../components/alert/swal';
import { STATUS_ENUM } from '../website-structure/content/enum/content.enum';
import { Box, Button } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { routeName } from '../../../routes/routeName';
import { useTranslation } from 'react-i18next';
import { RatingBox } from '../collections/element/RatingBox';
import { STATUS_DATA } from '../../../constants';
import StepperCustom from '../../../components/step/Stepper';
import StarsIcon from '@mui/icons-material/Stars';
import DescriptionIcon from '@mui/icons-material/Description';

type Props = {
    view: boolean;
}

const CalendarActivityDetail: React.FC<Props> = ({ view }: Props) => {
    const { t } = useTranslation();
    const { id } = useParams();
    const navigate = useNavigate();
    const [is_copy, set_is_copy] = useState<boolean>(false);

    const {
        formState,
        handleChangeFormState,
        handleSubmit,
        errorMessage,
        id_media_file,
        set_file_api_url,
        set_id_media_file,
        showModal,
        setFormState,
        handleCloseModal,
        image_api,
        handleChangeImageApi,
        setShowModal,
        handleDeleteImageApi,
        content_no,
        count_data,
        activity_category_data
    } = ManageStateDetail();

    const [step, setStep] = useState<number>(0);
    // console.log(image_api,'image_api')
    console.log(activity_category_data, 'activity_category_data')
    return (
        <ContainerLayout
            title=''
            titleName={id ? t('รายละเอียดกิจกรรม') : t('เพิ่มกิจกรรม')}
            navigateContent={
                <NavigateListCustom
                    navigateData={
                        [
                            {
                                key: "ปฏิทินกิจกรรม", // i18n-ignore
                                name: t("ปฏิทินกิจกรรม"),
                                pathName: routeName.cms_website.calendar_activity
                            },
                            ...((id && view) ? [
                                {
                                    key: "calendar_activity-view",
                                    name: t("รายละเอียดกิจกรรม"),
                                    pathName: routeName.cms_website.calendar_activity_view.replace(":id", id),
                                },
                            ] : (id && !view) ? [
                                {
                                    key: "calendar_activity_detail",
                                    name: t("รายละเอียดกิจกรรม"),
                                    pathName: routeName.cms_website.calendar_activity_detail.replace(":id", id),
                                },
                            ] : [
                                {
                                    key: "website_structure_content_create",
                                    name: t("เพิ่มกิจกรรม"),
                                    pathName: routeName.cms_website.calendar_activity_create,
                                },
                            ])
                        ]}
                />
            }

            buttonContent={
                <div className='w-full flex justify-end items-center gap-2'>
                    <StateComponents
                        typeProps={[
                            {
                                seq: 1,
                                gridProps: {
                                    xs: 12
                                },
                                hidden: formState.status === STATUS_ENUM.DRAFT || !id,
                                type: "TEXT_FIELD",
                                fieldProps: {
                                    value: content_no,
                                    placeholder: t('ลิ้งเชื่อมโยง'),
                                    endAdornment: <Button sx={{
                                        width: is_copy ? 240 : 150,
                                        opacity: is_copy ? .4 : 1,
                                        textTransform: 'none',
                                        transition: 'all .1s ease'
                                    }} variant='contained' startIcon={<ContentCopyIcon />} onClick={() => {
                                        set_is_copy(true);
                                        navigator.clipboard.writeText(content_no).then(() => {
                                            setTimeout(() => {
                                                set_is_copy(false)
                                            }, 1000)
                                        });
                                    }}>{is_copy ? 'loading..' : t('คัดลอก')}</Button>,
                                    onChange: () => { }
                                }
                            }
                        ]}
                    />
                    <ContainerButton
                        justifyContent='flex-end'
                        sxContainer={{ maxWidth: "fit-content" }}
                        buttonData={[
                            {
                                key: "BACK",
                                buttonProps: {
                                    onClick: () => navigate(-1)
                                },
                                label: t("ย้อนกลับ"),
                                seq: 1,
                                type: "BACK"
                            },
                            // {
                            //     key: "SAVE_DRAFT",
                            //     hidden: view,
                            //     buttonProps: {
                            //         onClick: () => handleSubmit("DRAFT")
                            //     },
                            //     label: "บันทึกร่าง",
                            //     seq: 2,
                            //     type: "SAVE_DRAFT"
                            // },
                            {
                                key: "SAVE",
                                hidden: view,
                                buttonProps: {
                                    onClick: () => {
                                        alertActive(t("บันทึกข้อมูล"), t("ท่านต้องการบันทึกข้อมูลเนื้อหา?"), t("บันทึก"), t("ยกเลิก"), () => {
                                            handleSubmit("SUBMIT")
                                        })
                                    }
                                },
                                label: t("บันทึก"),
                                seq: 3,
                                type: "SAVE"
                            },
                        ]}
                    />
                </div>
            }
            content={
                <>
                    {STATUS_DATA.ACTIVE === formState.status && (
                        <div className='flex justify-center items-center'>
                            <StepperCustom
                                sx={{ maxWidth: 'fit-content' }}
                                setStep={(s) => setStep(s)}
                                step={step}
                                view
                                stepLabel={[
                                    {
                                        icon: <DescriptionIcon />,
                                        isAccept: false,
                                        name: t("รายละเอียด"),
                                    },
                                    {
                                        icon: <StarsIcon />,
                                        isAccept: false,
                                        name: t("การเข้าถึง"),
                                    },
                                ]}
                            />
                        </div>
                    )}
                    {step === 0 && (
                        <div className='w-full'>
                            <StateComponents
                                disabledAllField={view}
                                otherProps={{ spacing: 2 }}
                                typeProps={[
                                    {
                                        seq: 1,
                                        type: "SWITCH",
                                        gridProps: {
                                            xs: 12
                                        },
                                        fieldProps: {
                                            disabled: view,
                                            checked: formState.is_public ? true : false,
                                            onChange: (val) => handleChangeFormState('is_public', val ? 1 : 0),
                                            label: t("สถานะการเผยแพร่")
                                        }
                                    },
                                    {
                                        seq: 2,
                                        type: "DATE",
                                        gridProps: {
                                            xs: 12,
                                            md: 3
                                        },
                                        fieldProps: {
                                            helperText: errorMessage.content_start_date,
                                            required: true,
                                            onChange: (date) => handleChangeFormState('content_start_date', date),
                                            value: formState.content_start_date,
                                            heading: t("วันที่เริ่มต้นเผยแพร่"),
                                            placeholder: t("ระบุ")
                                        }
                                    },
                                    {
                                        seq: 3,
                                        type: "DATE",
                                        gridProps: {
                                            xs: 12,
                                            md: 3
                                        },
                                        fieldProps: {
                                            helperText: errorMessage.content_end_date,
                                            required: true,
                                            disabled: view || !formState.content_start_date,
                                            disableStartDate: formState.content_start_date,
                                            onChange: (date) => handleChangeFormState('content_end_date', date),
                                            value: formState.content_end_date,
                                            heading: t("วันที่สิ้นสุดเผยแพร่"),
                                            placeholder: t("ระบุ")
                                        }
                                    },
                                    {
                                        seq: 4,
                                        type: "TIME_PICKER",
                                        gridProps: {
                                            xs: 12,
                                            md: 3
                                        },
                                        fieldProps: {
                                            helperText: errorMessage.content_start_time,
                                            required: true,
                                            value: formState.content_start_time,
                                            onChange: (e) => handleChangeFormState('content_start_time', e),
                                            heading: t("เวลาที่เริ่มต้นเผยแพร่"),
                                            placeholder: t("ระบุ")
                                        }
                                    },
                                    {
                                        seq: 5,
                                        type: "TIME_PICKER",
                                        gridProps: {
                                            xs: 12,
                                            md: 3
                                        },
                                        fieldProps: {
                                            helperText: errorMessage.content_end_time,
                                            required: true,
                                            value: formState.content_end_time,
                                            onChange: (e) => {
                                                handleChangeFormState('content_end_time', e)
                                            },
                                            heading: t("เวลาที่สิ้นสุดเผยแพร่"),
                                            placeholder: t("ระบุ")
                                        }
                                    },
                                ]}
                            />
                            <div className='w-full my-10'>
                                <BannerTypeContent
                                    value={formState.banner_type}
                                    disabled={view}
                                    onClick={(val) => !view && handleChangeFormState('banner_type', val)}
                                />
                            </div>
                            <div className='w-full shadow-md py-4 my-10 rounded-xl px-4'>
                                <StateComponents
                                    typeProps={[
                                        {
                                            seq: 1,
                                            type: "MULTI_UPLOAD_IMAGE",
                                            gridProps: {
                                                xs: 12
                                            },
                                            fieldProps: {
                                                handleDeleteImageApi: (_, i) => handleDeleteImageApi(i),
                                                handleDeleteImageSelect: () => { },
                                                onChange: () => { },
                                                tabIndex: 2,
                                                subheading: t("(ภาพแรกจะถูกนำไปใช้เป็นภาพหน้าปก และภาพแรกของแต่ละแพทเทิร์น)"),
                                                valueAddFile: [],
                                                heading: t('ไฟล์แกลเลอรี'),
                                                onUploadMedia: () => {
                                                    setShowModal("ADD")
                                                },
                                                is_using_modal_media: true,
                                                disabled: view,
                                                addImageIcon: <IconComponents.UploadImageFileIcon />,
                                                valueImage: image_api || []
                                            }
                                        },
                                    ]}
                                />
                            </div>
                            <div className='w-full grid grid-cols-12 gap-4 mt-6'>
                                <span className='col-span-12'>
                                    <StateComponents
                                        otherProps={{ spacing: 3 }}
                                        disabledAllField={view}
                                        typeProps={[
                                            {
                                                seq: 1,
                                                type: "TEXT_FIELD",
                                                gridProps: {
                                                    xs: 12,
                                                },
                                                fieldProps: {
                                                    disabled: view,
                                                    required: true,
                                                    helperText: errorMessage.content_name,
                                                    heading: t('หัวข้อข่าว'),
                                                    placeholder: t('ระบุ'),
                                                    value: formState.content_name,
                                                    onChange: (e) => handleChangeFormState('content_name', e.target.value)
                                                }
                                            },
                                            // {
                                            //     seq: 2,
                                            //     type: "TEXT_FIELD",
                                            //     gridProps: {
                                            //         xs: 12,
                                            //     },
                                            //     fieldProps: {
                                            //         disabled: view,
                                            //         heading: 'ข้อความย่อย',
                                            //         placeholder: 'ระบุ',
                                            //         value: formState.content_desc,
                                            //         onChange: (e) => handleChangeFormState('content_desc', e.target.value)
                                            //     }
                                            // },
                                            {
                                                seq: 3,
                                                type: "TEXT-EDITOR",
                                                gridProps: {
                                                    xs: 12,
                                                },
                                                fieldProps: {
                                                    disabled: view,
                                                    heading: t('รายละเอียด'),
                                                    placeholder: t('ระบุ'),
                                                    textString: formState.content_detail,
                                                    onChange: (e) => {
                                                        handleChangeFormState('content_detail', e);
                                                    }
                                                }
                                            },
                                        ]}
                                    />
                                </span>
                            </div>

                            <StateComponents
                                heading={t('รายละเอียดกิจกรรม')}
                                disabledAllField={view}
                                otherProps={{ spacing: 2 }}
                                typeProps={[
                                    {
                                        seq: 1,
                                        gridProps: {
                                            xs: 12,
                                            md: 3
                                        },
                                        type: "DATE",
                                        fieldProps: {
                                            placeholder: t("ระบุวันที่เริ่มจัดกิจกรรม"),
                                            heading: t("วันที่เริ่มจัดกิจกรรม"),
                                            onChange: (e) => handleChangeFormState('activity_start_date', e),
                                            value: formState.activity_start_date || "",
                                        }
                                    },
                                    {
                                        seq: 2,
                                        gridProps: {
                                            xs: 12,
                                            md: 3
                                        },
                                        type: "DATE",
                                        fieldProps: {
                                            placeholder: t("ระบุวันที่สิ้นสุดจัดกิจกรรม"),
                                            heading: t("วันที่สิ้นสุดจัดกิจกรรม"),
                                            disableStartDate: formState.activity_start_date,
                                            disabled: !formState.activity_start_date,
                                            onChange: (e) => handleChangeFormState('activity_end_date', e),
                                            value: formState.activity_end_date || "",

                                        }
                                    },
                                    {
                                        seq: 3,
                                        gridProps: {
                                            xs: 12,
                                            md: 3
                                        },
                                        type: "TIME_PICKER",
                                        fieldProps: {
                                            placeholder: t("ระบุเวลาที่เริ่มจัดกิจกรรม"),
                                            heading: t("เวลาที่เริ่มจัดกิจกรรม"),
                                            onChange: (e) => handleChangeFormState('activity_start_time', e),
                                            value: formState.activity_start_time || "",

                                        }
                                    },
                                    {
                                        seq: 4,
                                        gridProps: {
                                            xs: 12,
                                            md: 3
                                        },
                                        type: "TIME_PICKER",
                                        fieldProps: {
                                            placeholder: t("ระบุเวลาที่สิ้นสุดจัดกิจกรรม"),
                                            heading: t("เวลาที่สิ้นสุดจัดกิจกรรม"),
                                            onChange: (e) => handleChangeFormState('activity_end_time', e),
                                            value: formState.activity_end_time || "",

                                        }
                                    },
                                    {
                                        seq: 4,
                                        gridProps: {
                                            xs: 12,
                                        },
                                        type: "AUTO-COMPLETE",
                                        fieldProps: {
                                            getOptionLabel: (op) => op?.activity_category_name || "",
                                            labelId: "activity_category",
                                            options: activity_category_data || [],
                                            heading: t("หมวดหมู่"),
                                            placeholder: t("ระบุหมวดหมู่"),
                                            onChange: (_, val) => handleChangeFormState('id_activity_category', val?.id_activity_category ?? null),
                                            value: activity_category_data?.find((x) => x?.id_activity_category === formState.id_activity_category) || null,

                                        }
                                    },
                                ]}
                            />

                            {showModal !== "" && (
                                <ModalMedia
                                    open
                                    handleClose={handleCloseModal}
                                    title={t('เพิ่มไฟล์')}
                                    id_media_file={id_media_file}
                                    multiple
                                    onSelectMediaFile={(_, id) => set_id_media_file(id)}
                                    onSubmitMediaFile={async (_, id_media_file) => {
                                        handleCloseModal();
                                        const path = await linkPreviewImage(id_media_file);
                                        set_file_api_url(path);
                                        setFormState((prev) => ({ ...prev, id_media_file }))
                                        // handleSubmit(id_media_file);
                                    }}
                                    onSubmitMediaFileMultiple={(media_file) => {
                                        handleChangeImageApi(media_file)

                                    }}
                                    onSubmitLocalFile={async (id_media_file) => {
                                        const path = await linkPreviewImage(id_media_file);
                                        setFormState((prev) => ({ ...prev, id_media_file }))
                                        set_file_api_url(path);
                                        handleCloseModal();
                                        // handleSubmit(id_media_file);
                                    }}
                                />
                            )}
                        </div>
                    )}


                    {step === 1 && (
                        <Box className="w-full flex gap-4 items-center justify-center py-5">
                            {
                                [
                                    { label: t("ยอดการถูกใจ"), icon: <IconComponents.HeartIcon />, count: count_data?.total_like },
                                    { label: t("ยอดการเข้าชม"), icon: <IconComponents.ViewIcon />, count: count_data?.total_view },
                                    { label: t("ยอดการแชร์"), icon: <IconComponents.SharedIcon />, count: count_data?.total_shared },
                                ].map((list) => {
                                    return (
                                        <RatingBox
                                            IconData={list.icon}
                                            count={list.count}
                                            title={list.label}
                                        />
                                    )
                                })
                            }
                        </Box>
                    )}
                </>
            }
        />
    )
}

export default CalendarActivityDetail